/* eslint-disable consistent-return */
/* eslint-disable new-cap */
import React, { useContext, useState } from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

// core components
import { useQuery } from "react-query";
import ApiContext from "services/ApiContext";
import ShopContext from "services/ShopContext";
import BasicTable from "views/tables/BasicTable";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../sales.css";
import moment from "moment";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import DeleteMerchandise from "./DeleteMerchandise";

const columns = [
  {
    name: "ID",
    selector: (row) => <p>{`#${row.ID}`}</p>,
    sortable: true,
    wrap: true,
  },
  {
    name: "Create Date",
    selector: (row) => (
      <div>
        <p>{moment(row.OrderCreatedDate).format("DD/MM/YYYY")}</p>
        {moment(row.OrderCreatedDate).format("hh:mm A")}
      </div>
    ),
  },
  {
    name: "Item",
    selector: (row) => {
      if (!row) return null;
      return (
        <div>
          {row.AttachmentUrlList.length === 0 ? (
            <p>No image</p>
          ) : (
            <img
              src={row.AttachmentUrlList[0].ImageUrl}
              alt="merchandise img"
              className="p-2"
            />
          )}
        </div>
      );
    },
    sortable: true,
    wrap: true,
  },
  {
    name: "Status",
    selector: (row) => (
      <p>{row.Status === true ? <p>Active</p> : <p>Deactivated</p>}</p>
    ),
    sortable: true,
    wrap: true,
  },
  {
    name: "StockCount",
    selector: (row) => row.StockCount,
    sortable: true,
    wrap: true,
  },
  {
    name: "Name",
    selector: (row) => row.EngName,
    sortable: true,
    wrap: true,
  },
  {
    name: "SKU",
    selector: (row) => row.SKU,
    sortable: true,
    wrap: true,
  },
  {
    name: "Action",
    selector: (row) => {
      const [showModal, setShowModal] = useState({
        mID: "",
        open: false,
      });

      if (!row) return null;

      return (
        <div>
          <Button
            id="itemhover"
            color="link"
            key={row.ID}
            className="pl-0 pr-0"
            tag={Link}
            to={`/shopowner/sales/Merchandise/${row.ID}`}
          >
            <i
              className="fa fa-search-plus"
              aria-hidden="true"
              style={{ color: "white", fontSize: "18px" }}
              title="Order Detais"
            />
          </Button>

          <Button
            id="itemhover"
            color="link"
            key={row.ID}
            className="pl-3 pr-3"
            onClick={() =>
              setShowModal({
                mID: row.ID,
                open: !showModal.open,
              })
            }
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
              style={{ color: "white", fontSize: "18px" }}
              title="Order Detais"
            />
          </Button>
          <Modal
            size="lg"
            isOpen={showModal.open}
            toggle={() =>
              setShowModal({
                ...showModal,
                open: !showModal.open,
              })
            }
          >
            <ModalHeader>
              <Button
                className="btn btn-primary float-right"
                style={{ fontSize: "12px" }}
                size="sm"
                onClick={() =>
                  setShowModal({
                    ...showModal,
                    open: false,
                  })
                }
              >
                x
              </Button>
              {row.EngName}
            </ModalHeader>
            <ModalBody>
              <DeleteMerchandise
                mID={showModal.mID}
                setShowModal={setShowModal}
                showModal={showModal}
              />
            </ModalBody>
          </Modal>
        </div>
      );
    },
    wrap: true,
  },
];

const ExampleCustomInput = React.forwardRef(
  // eslint-disable-next-line react/prop-types
  ({ value, children, onClick }, ref) => (
    <Input
      ref={ref}
      value={value}
      onClick={onClick}
      placeholder="Date Range for filter"
      className="h-100"
    >
      {children}
    </Input>
  )
);

function Merchandise() {
  const shopID = useContext(ShopContext).selctShopID.ID;
  const Axios = useContext(ApiContext);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [dateRange, setDateRange] = React.useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [filterDataResult, setFilterDataResult] = React.useState([]);
  const [selectedData, setSelectedData] = React.useState([]);

  const handleSelectRows = ({ selectedRows }) => {
    setSelectedData(selectedRows);
  };

  const { isLoading, data, isSuccess, refetch } = useQuery(
    `/shop/${shopID}/Merchandise/GetAllMerchandise`,
    async () => {
      if (shopID !== "0") {
        const res = await Axios.get(
          `/shop/${shopID}/Merchandise/GetAllMerchandise`
        );
        setFilterDataResult(res.data);
        refetch();
        return res;
      }
    },
    { refetchOnWindowFocus: false }
  );
  const resetFilter = () => {
    setDateRange([null, null]);
    setFilterDataResult(data.data);
  };

  const filterData = () => {
    if (isSuccess) {
      const finalData = data.data.Result.filter((item) =>
        startDate !== null
          ? new Date(item.OrderDate) >=
            new Date(
              moment(startDate).set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
              })
            ).getTime()
          : item
      )
        .filter((item) =>
          endDate !== null
            ? new Date(item.OrderDate) <=
              new Date(
                moment(endDate).set({
                  hour: 0,
                  minute: 0,
                  second: 0,
                  millisecond: 0,
                })
              ).getTime()
            : item
        )
        .filter(
          (item) =>
            (item.Name &&
              item.Name.toLowerCase().includes(searchQuery.toLowerCase())) ||
            (item.Invoice &&
              item.Invoice.toLowerCase().includes(searchQuery.toLowerCase()))
        );
      setFilterDataResult(finalData);
    }
  };

  const convertToCSV = (data2) => {
    const header = ["ID", "Create Date", "Status", "StockCount", "Name", "SKU"];
    const csv = [
      header.join(","),
      ...data2.map((row) =>
        header
          .map((fieldName) => {
            if (fieldName === "ID") {
              return `#${row.ID}`;
            }
            if (fieldName === "Create Date") {
              return JSON.stringify(
                moment(row.OrderCreatedDate).format("DD/MM/YYYY hh:mm A")
              );
            }

            if (fieldName === "SKU") {
              return JSON.stringify(row.SKU);
            }
            if (fieldName === "StockCount") {
              return JSON.stringify(row.StockCount);
            }

            if (fieldName === "Name") {
              return JSON.stringify(row.EngName);
            }

            if (fieldName === "Status") {
              const logisticText =
                row.Status === true ? "Active" : "Deactivated";
              return logisticText;
            }
            return JSON.stringify(row[fieldName]);
          })
          .join(",")
      ),
    ].join("\n");
    return csv;
  };

  const downloadCSV = (jsonData) => {
    const csv = convertToCSV(jsonData);
    const csvBlob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(csvBlob);
      link.setAttribute("href", url);
      link.setAttribute("download", "data.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  if (isLoading) {
    return (
      <Col className="text-center" md="12">
        <div className="uil-reload-css reload-background mr-1 align-center">
          <div className="" />
        </div>
      </Col>
    );
  }
  return (
    <div className="content px-3 w-100" style={{ overflowX: "auto" }}>
      <Card className="card-dark" style={{ minWidth: "350px" }}>
        <CardHeader>
          <CardTitle tag="h4">Merchandise List</CardTitle>
        </CardHeader>
        <CardBody>
          <Row xs={1} sm={2} className="my-2">
            <Col>
              <div>Filter Date: </div>
              <div className="d-flex">
                <ReactDatePicker
                  calendarClassName="h-100"
                  wrapperClassName="w-100 "
                  isClearable
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  dateFormat="dd/MM/yyyy"
                  customInput={<ExampleCustomInput />}
                />
                <Button className="ml-1  my-0" onClick={() => filterData()}>
                  Filter
                </Button>
              </div>
            </Col>
            <Col className="mt-2 mt-sm-0">
              <div>Search: </div>
              <div className="d-flex">
                <Input
                  onChange={(e) => setSearchQuery(e.target.value)}
                  value={searchQuery}
                />
                <Button className="ml-1  my-0" onClick={() => filterData()}>
                  Search
                </Button>
              </div>
            </Col>
          </Row>
          <div className="d-flex align-items-center">
            <Button
              className="ml-1"
              color="danger"
              onClick={() => resetFilter()}
            >
              Reset All Filter
            </Button>
          </div>
          <div className="d-flex align-items-center">
            <span className="mr-2" style={{ fontSize: "16px" }}>
              Bulk Action:
            </span>

            <Button
              outline
              color="filter"
              onClick={() => {
                downloadCSV(
                  selectedData.length > 0 ? selectedData : filterDataResult
                );
              }}
            >
              Export CSV
            </Button>
          </div>
          <Button
            className="float-right"
            outline
            color="filter"
            tag={Link}
            to="/shopowner/salesMerchandise/NewMerchandise"
          >
            Add New Merchandise
          </Button>
          {isSuccess && data && (
            <div id="" className="mt-5">
              <BasicTable
                pagination
                id=""
                selectableRows
                onSelectedRowsChange={handleSelectRows}
                subHeaderWrap
                progressPending={isLoading}
                data={filterDataResult}
                columns={columns || []}
              />
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
}

export default Merchandise;
